import { useEffect, useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, clearToken, getToken } from "../lib/api";

export default function AdminLayout() {
  const nav = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    if (!getToken()) return;
    api.get("/auth/me").then((r) => setMe(r.data)).catch(() => {
      clearToken();
      nav("/admin/login");
    });
  }, [nav]);

  if (!getToken()) return <Navigate to="/admin/login" replace />;

  const logout = () => {
    clearToken();
    toast.success("Signed out.");
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-bone flex" data-testid="admin-layout">
      <aside className="w-64 shrink-0 border-r border-borderWarm bg-stone2/40 p-8 hidden md:flex md:flex-col justify-between">
        <div>
          <p className="font-serif text-2xl tracking-[0.05em] text-ink">Muse<span className="text-gold">n</span>Aura</p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-muteInk mt-1">Studio · Admin</p>
          <nav className="mt-14 space-y-1">
            {[
              { to: "/admin", label: "Projects", end: true },
              { to: "/admin/leads", label: "Leads" },
            ].map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`admin-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `block px-4 py-3 text-[12px] uppercase tracking-[0.22em] border-l-2 ${
                    isActive ? "border-clay text-ink bg-bone" : "border-transparent text-muteInk hover:text-ink"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div>
          {me && <p className="text-[11px] uppercase tracking-[0.24em] text-muteInk mb-3">{me.email}</p>}
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="w-full border border-ink py-2.5 text-[11px] uppercase tracking-[0.22em] hover:bg-ink hover:text-bone transition-colors duration-300"
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
